<div class="flex-column gap">
    <div class="grid-4col input-grid-gaps pt-2">
        <app-date-input
            [form]="form"
            id="entryDate"
            [prefix]="prefix"
        ></app-date-input>

        <app-date-input
            [form]="form"
            id="dateTo"
            [prefix]="prefix"
        ></app-date-input>

        <app-select-input
            [form]="form"
            id="removalReason"
            [staticOptions]="waitingListRemovalReasonOptions"
            valueKey="value"
            [prefix]="prefix"
        ></app-select-input>

        <app-check-input
            [form]="form"
            id="readyToUseService"
            [prefix]="prefix"
        ></app-check-input>
    </div>

    <div class="grid-2col input-grid-gaps pt-2">
        <div class="flex-column gap">
            <app-card class="flex-column gap" [title]="'waitingList.attendant.titleGeneral'">
                <ng-template #content>
                    <app-service-pattern-wysiwyg
                        [form]="form"
                        id="note"
                        editorKey="waitingList.note"
                        [height]="undefined"
                        [serviceId]="item.folder.serviceId"
                        [folderId]="item.folderId"
                        [usage]="ServicePatternStructureUsageEnum.WAITING_LIST_NOTE"
                        (addedPattern)="formAddText(form, 'note', $event.content)"
                        [patternGroups]="wysiwygPatterGroupsFolder"
                    ></app-service-pattern-wysiwyg>

                    <app-select-user
                        class="w-full"
                        [form]="form"
                        id="userId"
                        label="waitingList.attendant.fields.userId"
                        [serviceId]="item.folder.serviceId"
                        [employment]="EmploymentParentGroupEnum.DIRECT_CARE"
                    ></app-select-user>

                    <app-multi-select-input
                        id="form"
                        [form]="form"
                        class="fr-2"
                        [staticOptions]="serviceFormOptions"
                        [showClear]="false"
                        valueKey="value"
                        label="service.serviceBasicInfoForm.form"
                        display="comma"
                    ></app-multi-select-input>
                </ng-template>
            </app-card>

            <app-file-upload-box
                [multiple]="true"
                [existingFiles]="form.value.files"
            ></app-file-upload-box>
        </div>

        <app-card-table
            #ratingsTable
            [tableTitle]="'waitingList.attendant.ratings.title'"
            tableKey="waitingListRatings"
            [translatePrefix]="prefix + 'ratings.'"
            [columns]="ratingColumns()"
            [gridData]="$any(store.data.getWaitingListRatings())"
            [refreshCallback]="store.api.getWaitingListRatings"
            [refreshCallbackFragment]="ratingsFrag"
            [additionalFilter]="$any(additionalFilter())"
            [showColumnVisiblity]="true"
            [smallButtons]="true"
            [hideCheckboxes]="true"
            [defaultSorters]="[{ column: 'date', direction: 'DESC' }]"
            (createCallback)="openRating()"
            (detailCallback)="openRating($event)"
            (deleteCallbackWithEvent)="deleteRating($event)"
        ></app-card-table>
    </div>
</div>
